module.exports = __webpack_public_path__ + "img/logo-v5.2a9969e7.jpg";